/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber6Small = createReactComponent("number-6-small", "IconNumber6Small", [
  [
    "path",
    {
      d: "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3",
      key: "svg-0"
    }
  ]
]);

export { IconNumber6Small as default };
//# sourceMappingURL=IconNumber6Small.js.map
